import { FileSpreadsheetIcon, LayoutTemplateIcon, MessageCircleIcon, CalendarCheckIcon } from "lucide-react";

/**
 * Los valores de referencia (tachados) de cada bono están por mercado en data/markets.ts,
 * en el mismo orden que esta lista.
 * `shortTitle`: versión breve usada en la tarjeta de compra.
 */
export const bonuses = [
  {
    icon: FileSpreadsheetIcon,
    title: "Excel de costos y pedidos",
    shortTitle: "Excel de costos",
    text: "Cargas tus ingredientes y la planilla calcula el costo de cada receta. Además, registra pedidos, entregas y cobros.",
  },
  {
    icon: LayoutTemplateIcon,
    title: "Plantillas para Instagram y catálogo",
    shortTitle: "Plantillas",
    text: "Diseños editables para tus publicaciones, historias y un catálogo listo para compartir con tus clientes.",
  },
  {
    icon: MessageCircleIcon,
    title: "57 mensajes para WhatsApp",
    shortTitle: "57 mensajes",
    text: "Textos listos para copiar: saludo, precios, toma de pedido, recordatorio de pago, entrega y seguimiento.",
  },
  {
    icon: CalendarCheckIcon,
    title: "Plan de acción de 30 días",
    shortTitle: "Plan de 30 días",
    text: "Una tarea concreta para cada día. Sabes exactamente qué hacer hoy, sin tener que pensar por dónde seguir.",
  },
];
